// Verde vocabulary expansion — TIME & WEATHER theme (net-new cards).
//
// Extends the `time-weather` blocks in ./vocabulary.js without reusing any
// headword already defined there. Seed upserts on `spanish`, so every value is
// unique.
//   [ spanish, english, emoji, part_of_speech, gender, example_es, example_en ]

export const VOCAB_TIME_WEATHER = [
  {
    theme: "time-weather", tier: "A1", rows: [
      ["la semana", "week", "📅", "noun", "f", "La semana tiene siete días.", "The week has seven days."],
      ["el mes", "month", "🗓️", "noun", "m", "Julio es mi mes favorito.", "July is my favourite month."],
      ["el año", "year", "🎉", "noun", "m", "El año empieza en enero.", "The year starts in January."],
      ["la hora", "hour / time", "🕐", "noun", "f", "¿Qué hora es?", "What time is it?"],
      ["la tarde", "afternoon / evening", "🌇", "noun", "f", "Por la tarde hace más calor.", "It's hotter in the afternoon."],
      ["llover", "to rain", "🌧️", "verb", "", "Va a llover esta tarde.", "It's going to rain this afternoon."],
      ["nevar", "to snow", "🌨️", "verb", "", "En enero suele nevar.", "It usually snows in January."],
      ["el arcoíris", "rainbow", "🌈", "noun", "m", "Salió un arcoíris tras la lluvia.", "A rainbow came out after the rain."],
      ["el paraguas", "umbrella", "☂️", "noun", "m", "Lleva el paraguas, por si acaso.", "Take the umbrella, just in case."],
      ["el calor", "heat", "🥵", "noun", "m", "No soporto el calor de agosto.", "I can't stand the August heat."],
    ],
  },
  {
    theme: "time-weather", tier: "A2", rows: [
      ["el clima", "climate", "🌍", "noun", "m", "El clima del norte es más suave.", "The climate in the north is milder."],
      ["la previsión", "forecast", "📡", "noun", "f", "La previsión anuncia lluvia.", "The forecast announces rain."],
      ["la brisa", "breeze", "🍃", "noun", "f", "Sopla una brisa agradable.", "A pleasant breeze is blowing."],
      ["la helada", "frost", "❄️", "noun", "f", "Hubo una helada esta noche.", "There was a frost last night."],
      ["el trueno", "thunder", "🌩️", "noun", "m", "El trueno asustó al perro.", "The thunder scared the dog."],
      ["el charco", "puddle", "💧", "noun", "m", "El niño saltó en el charco.", "The child jumped in the puddle."],
      ["la sombra", "shade / shadow", "🌳", "noun", "f", "Comemos a la sombra del árbol.", "We eat in the shade of the tree."],
      ["mojado", "wet", "💦", "adjective", "", "El suelo está mojado.", "The floor is wet."],
      ["la primavera", "spring", "🌸", "noun", "f", "En primavera todo florece.", "In spring everything blossoms."],
      ["el invierno", "winter", "⛄", "noun", "m", "El invierno aquí es muy frío.", "Winter here is very cold."],
    ],
  },
  {
    theme: "time-weather", tier: "B1", rows: [
      ["el frente", "weather front", "🌀", "noun", "m", "Un frente frío llega mañana.", "A cold front arrives tomorrow."],
      ["la ola de calor", "heatwave", "🔥", "phrase", "", "La ola de calor durará una semana.", "The heatwave will last a week."],
      ["el aguacero", "downpour", "🌧️", "noun", "m", "Nos pilló un aguacero sin paraguas.", "A downpour caught us without an umbrella."],
      ["la borrasca", "storm system", "🌪️", "noun", "f", "La borrasca trae viento y lluvia.", "The storm system brings wind and rain."],
      ["el deshielo", "thaw", "🫠", "noun", "m", "El deshielo llena los ríos en abril.", "The thaw fills the rivers in April."],
      ["el calentamiento global", "global warming", "🌡️", "phrase", "", "El calentamiento global cambia las estaciones.", "Global warming is shifting the seasons."],
      ["bochornoso", "muggy / sultry", "😓", "adjective", "", "El día está bochornoso y pegajoso.", "The day is muggy and sticky."],
      ["el rocío", "dew", "🌫️", "noun", "m", "Por la mañana hay rocío en la hierba.", "In the morning there's dew on the grass."],
      ["el chaparrón", "heavy shower", "⛈️", "noun", "m", "Cayó un chaparrón de diez minutos.", "A ten-minute heavy shower fell."],
      ["caluroso", "hot (of weather)", "☀️", "adjective", "", "Fue un verano muy caluroso.", "It was a very hot summer."],
    ],
  },
];
